import { ItemIndicator, RadioItem } from "@radix-ui/react-dropdown-menu";
import { ReactNode, forwardRef } from "react";

const DropdownMenuRadioItem = forwardRef<
  React.ElementRef<typeof RadioItem>,
  React.ComponentPropsWithoutRef<typeof RadioItem> & { Icon?: ReactNode }
>(({ className, Icon, children, ...props }, ref) => (
  <RadioItem
    ref={ref}
    className={`relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-hidden transition-colors focus:bg-muted dark:bg-muted/10 focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50
      ${className}
    `}
    {...props}
  >
    <span className="absolute left-2 flex h-3.5 w-3.5 items-center justify-center">
      <ItemIndicator>{Icon}</ItemIndicator>
    </span>
    {children}
  </RadioItem>
));
DropdownMenuRadioItem.displayName = RadioItem.displayName;
export { DropdownMenuRadioItem };
